(() => {
  let scheduled = false;
  let bisWidgetObserver = null;
  let bisDiscoveryObserver = null;
  let bisApplyScheduled = false;

  function languageKey() {
    const lang = String(document.documentElement.lang || 'en').toLowerCase();
    if (lang.startsWith('sv')) return 'sv';
    if (lang.startsWith('nb') || lang.startsWith('no') || lang.startsWith('nn')) return 'nb';
    return 'en';
  }

  const COPY = {
    sv: {
      cartTrust: 'Säker betalning · Klarna · 14 dagars öppet köp',
      related: 'Du kanske också gillar',
      cartCrossSell: 'Du kanske också gillar',
      bestsellers: 'Bästsäljare'
    },
    nb: {
      cartTrust: 'Sikker betaling · Klarna · 14 dagers åpent kjøp',
      related: 'Du vil kanskje også like',
      cartCrossSell: 'Du vil kanskje også like',
      bestsellers: 'Bestselgere'
    },
    en: {
      cartTrust: 'Secure checkout · Klarna · 14-day returns',
      related: 'You may also like',
      cartCrossSell: 'You may also like',
      bestsellers: 'Bestsellers'
    }
  };

  function copy(key) {
    const pack = COPY[languageKey()] || COPY.en;
    return pack[key] || COPY.en[key] || '';
  }

  function enhanceCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const crossSellTitle = drawer.querySelector('.cart-drawer__cross-sell .h7');
    if (crossSellTitle) crossSellTitle.textContent = copy('cartCrossSell');
  }

  function localizeRelatedProducts() {
    const section = document.querySelector('.shopify-section--related-products');
    if (!section) return;

    const knownTitles = new Set([
      'Du kanske också gillar',
      'You may also like',
      'Du vil kanskje også like',
      'Related products'
    ]);

    for (const element of section.querySelectorAll('h1, h2, h3, h4, h5, h6, p, .heading, .h5, .h6, .h7')) {
      if (knownTitles.has(element.textContent.trim())) {
        element.textContent = copy('related');
        break;
      }
    }
  }

  function localizeSearchMerchandising() {
    const drawer = document.querySelector('#search-drawer');
    if (!drawer) return;

    const knownFeatured = new Set(['Featured products', 'Bestsellers', 'Bästsäljare', 'Bestselgere']);
    for (const element of drawer.querySelectorAll('.subheading')) {
      if (knownFeatured.has(element.textContent.trim())) element.textContent = copy('bestsellers');
    }
  }

  function setImportantStyle(element, property, value) {
    if (!element || !element.style) return;
    if (
      element.style.getPropertyValue(property) === value &&
      element.style.getPropertyPriority(property) === 'important'
    ) return;
    element.style.setProperty(property, value, 'important');
  }

  function forceFullWidth(element) {
    setImportantStyle(element, 'width', '100%');
    setImportantStyle(element, 'max-width', 'none');
    setImportantStyle(element, 'margin-left', '0px');
    setImportantStyle(element, 'margin-right', '0px');
    setImportantStyle(element, 'box-sizing', 'border-box');
  }

  function visibleLargeClickable(root, minimumWidth) {
    if (!root || !root.querySelectorAll) return null;

    const candidates = Array.from(
      root.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"], a')
    ).filter((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.width <= 0 || rect.height < 36) return false;
      if (minimumWidth && rect.width < minimumWidth) return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
    });

    candidates.sort((a, b) => {
      const aRect = a.getBoundingClientRect();
      const bRect = b.getBoundingClientRect();
      return (bRect.width * bRect.height) - (aRect.width * aRect.height);
    });

    return candidates[0] || null;
  }

  function expandClickablePath(clickable, stopElement) {
    if (!clickable) return;
    forceFullWidth(clickable);

    let parent = clickable.parentElement;
    while (parent && parent !== stopElement) {
      forceFullWidth(parent);
      parent = parent.parentElement;
    }
  }

  function expandInsideRoot(root, widget, blockWidth) {
    if (!root) return false;
    if (root.host) forceFullWidth(root.host);

    const clickable = visibleLargeClickable(root, Math.max(120, blockWidth * 0.45));
    if (!clickable) return false;

    expandClickablePath(clickable, root === widget ? widget : null);
    return true;
  }

  function applyBackInStockWidth() {
    bisApplyScheduled = false;

    const widget = document.getElementById('sealapps-bis-widget');
    if (!widget) return false;

    const block = widget.closest('.product-info__block-item');
    if (!block) return false;

    forceFullWidth(block);
    forceFullWidth(widget);

    const blockWidth = block.getBoundingClientRect().width;
    if (!blockWidth) return true;

    let foundClickable = expandInsideRoot(widget, widget, blockWidth);
    for (const element of widget.querySelectorAll('*')) {
      if (!element.shadowRoot) continue;
      forceFullWidth(element);
      if (expandInsideRoot(element.shadowRoot, widget, blockWidth)) foundClickable = true;
    }

    if (!foundClickable && widget.firstElementChild) forceFullWidth(widget.firstElementChild);

    if (!bisWidgetObserver) {
      bisWidgetObserver = new MutationObserver(scheduleBackInStockWidth);
      bisWidgetObserver.observe(widget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    if (bisDiscoveryObserver) {
      bisDiscoveryObserver.disconnect();
      bisDiscoveryObserver = null;
    }

    return true;
  }

  function scheduleBackInStockWidth() {
    if (bisApplyScheduled) return;
    bisApplyScheduled = true;
    requestAnimationFrame(applyBackInStockWidth);
  }

  function watchBackInStockWidth() {
    const productSection = document.querySelector('.shopify-section--main-product');
    if (!productSection) return;

    if (applyBackInStockWidth() || bisDiscoveryObserver) return;

    bisDiscoveryObserver = new MutationObserver(() => {
      if (document.getElementById('sealapps-bis-widget')) scheduleBackInStockWidth();
    });
    bisDiscoveryObserver.observe(productSection, { childList: true, subtree: true });

    setTimeout(() => {
      if (!bisDiscoveryObserver) return;
      bisDiscoveryObserver.disconnect();
      bisDiscoveryObserver = null;
    }, 15000);
  }

  function run() {
    enhanceCartDrawer();
    localizeRelatedProducts();
    localizeSearchMerchandising();
    watchBackInStockWidth();
  }

  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  function start() {
    run();

    [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'cart:update',
      'ajaxProduct:added',
      'product:added',
      'shopify:section:load'
    ].forEach((eventName) => document.addEventListener(eventName, scheduleRun));

    document.addEventListener('click', (event) => {
      if (event.target.closest('button[name="add"], [data-add-to-cart], [data-cart-add], product-form button[type="submit"]')) {
        setTimeout(scheduleRun, 250);
        setTimeout(scheduleRun, 700);
      }
    }, true);

    window.addEventListener('resize', scheduleBackInStockWidth, { passive: true });
    [100, 300, 700, 1500, 3000].forEach((delay) => setTimeout(scheduleBackInStockWidth, delay));

    new MutationObserver(scheduleRun).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* LYLA CRO — SealApps popup CTA: one line + bold only. */
(() => {
  const media = window.matchMedia('(max-width: 749px)');
  let queued = false;

  function important(element, property, value) {
    if (element && element.style) element.style.setProperty(property, value, 'important');
  }

  function visible(element) {
    if (!element || !element.getBoundingClientRect) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width < 1 || rect.height < 1) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
  }

  function allOpenRoots() {
    const roots = [document];
    const queue = [document];
    const seen = new Set(queue);

    while (queue.length) {
      const root = queue.shift();
      if (!root.querySelectorAll) continue;
      for (const element of root.querySelectorAll('*')) {
        if (element.shadowRoot && !seen.has(element.shadowRoot)) {
          seen.add(element.shadowRoot);
          roots.push(element.shadowRoot);
          queue.push(element.shadowRoot);
        }
      }
    }
    return roots;
  }

  function isBisCtaText(text) {
    const value = String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return (
      (value.includes('mejla mig') && value.includes('lager')) ||
      (value.includes('email me') && (value.includes('available') || value.includes('back in stock'))) ||
      (value.includes('notify me') && (value.includes('available') || value.includes('back in stock'))) ||
      (value.includes('send meg') && value.includes('lager'))
    );
  }

  function composedParent(element) {
    if (!element) return null;
    if (element.parentElement) return element.parentElement;
    const root = element.getRootNode && element.getRootNode();
    return root && root.host ? root.host : null;
  }

  function hasModalContext(element) {
    let current = element;
    for (let i = 0; current && i < 16; i += 1) {
      if (current.nodeType === 1) {
        const style = getComputedStyle(current);
        if (
          current.getAttribute('role') === 'dialog' ||
          current.getAttribute('aria-modal') === 'true' ||
          style.position === 'fixed'
        ) return true;
      }
      current = composedParent(current);
    }
    return false;
  }

  function styleCta(cta) {
    if (!media.matches || !hasModalContext(cta)) return;

    important(cta, 'font-weight', '700');
    important(cta, 'white-space', 'nowrap');
    important(cta, 'word-break', 'normal');
    important(cta, 'overflow-wrap', 'normal');

    for (const child of cta.querySelectorAll('span, div, p')) {
      if (!String(child.textContent || '').trim()) continue;
      important(child, 'font-weight', '700');
      important(child, 'white-space', 'nowrap');
      important(child, 'word-break', 'normal');
      important(child, 'overflow-wrap', 'normal');
    }
  }

  function scan() {
    queued = false;
    if (!media.matches) return;

    for (const root of allOpenRoots()) {
      if (!root.querySelectorAll) continue;
      for (const element of root.querySelectorAll('button, [role="button"], a, input[type="button"], input[type="submit"]')) {
        const text = element.value || element.textContent || '';
        if (visible(element) && isBisCtaText(text)) styleCta(element);
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  function burst() {
    [0, 80, 180, 350, 700, 1200].forEach((delay) => setTimeout(schedule, delay));
  }

  function clickTouchesBisWidget(event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    return path.some((node) => {
      if (!node || node.nodeType !== 1) return false;
      if (node.id === 'sealapps-bis-widget') return true;
      return Boolean(node.closest && node.closest('#sealapps-bis-widget'));
    });
  }

  document.addEventListener('click', (event) => {
    if (media.matches && clickTouchesBisWidget(event)) burst();
  }, true);
})();
